import { render } from "./App.vue?vue&type=template&id=af8f5e62"
const script = {}

import "./App.vue?vue&type=style&index=0&id=af8f5e62&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__